import { cn } from '@/lib/utils';
import { useProfessionalCalendar } from '@/context/ProfessionalCalendarContext';
import {
	professionalHeaderControlHeightClass,
	professionalHeaderControlPaddingClass,
	professionalHeaderControlTextClass,
} from './professionalHeaderConstants';

const groupedPillClass = cn(
	'flex items-stretch gap-0.5 rounded-full border border-zinc-200 bg-zinc-100/80 p-0.5',
	professionalHeaderControlHeightClass,
);

const toggleButtonClass = cn(
	'h-full rounded-full outline-none ring-0 transition-all focus:outline-none focus:ring-0 active:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-300/70',
	professionalHeaderControlPaddingClass,
	professionalHeaderControlTextClass,
);

const ProfessionalHeaderCalendarViewPill = ({
	className,
}: {
	className?: string;
}) => {
	const { view, handleViewChange } = useProfessionalCalendar();

	return (
		<div
			className={cn(groupedPillClass, className)}
			role="group"
			aria-label="Visualização do calendário"
		>
			<button
				type="button"
				onClick={() => handleViewChange('WEEK')}
				className={cn(
					toggleButtonClass,
					'flex-1',
					view === 'WEEK'
						? 'bg-white text-zinc-800 shadow-sm'
						: 'text-zinc-500 hover:text-zinc-700',
				)}
			>
				Semana
			</button>
			<button
				type="button"
				onClick={() => handleViewChange('MONTH')}
				className={cn(
					toggleButtonClass,
					'flex-1',
					view === 'MONTH'
						? 'bg-white text-zinc-800 shadow-sm'
						: 'text-zinc-500 hover:text-zinc-700',
				)}
			>
				Mês
			</button>
		</div>
	);
};

export { ProfessionalHeaderCalendarViewPill };
